angular.module('impactx.rfx').controller('RFXSupplierTermsDialogCtrl', [
    'TranslationService',
    '$mdDialog',
    'BackService',
    'DownloadService',
    'themeFactory',
    RFXSupplierTermsDialogCtrl
]);

function RFXSupplierTermsDialogCtrl(TranslationService, $mdDialog, BackService, DownloadService, themeFactory) {
    var self = this;
    self.abortLabel = TranslationService.get("abort");

    self.accept = function () {
        $mdDialog.hide();
    };

    self.abort = function () {
        BackService.back();
        $mdDialog.hide();
    };

    self.downloadAttachment = function (media) {
        DownloadService.openDownloadPost('/rfx/download/media', {paramName: "id", paramValue: media.id});
    };

    self.theme = themeFactory.getTheme();
}